import base from '../base'

export default {
  queryUrl:`${base.url}/business/messageTemplate/logList`,
  sendFake:`${base.url}/business/messageTemplate/sendFake`,
  getTemplateCode:`${base.url}/business/messageTemplate/getTemplateCode`,
  emailCodeList:`${base.url}/business/verifyCodeSetting/list`,
  emailCodeSave:`${base.url}/business/verifyCodeSetting/save`,
  emailCodeEdit:`${base.url}/business/verifyCodeSetting/edit`,
  emailCodeDel:`${base.url}/business/verifyCodeSetting/del`,
  sendEmailCodeFake:`${base.url}/business/messageTemplate/sendEmailCodeFake`,
  logEmailCodeList:`${base.url}/business/messageTemplate/logEmailCodeList`,
  export:`${base.url}/business/messageTemplate/export`,
  emailExport:`${base.url}/business/messageTemplate/emailExport`,
}
